import { render, staticRenderFns } from "./Third-party.vue?vue&type=template&id=d5150516&scoped=true"
import script from "./Third-party.vue?vue&type=script&lang=js"
export * from "./Third-party.vue?vue&type=script&lang=js"
import style0 from "./Third-party.vue?vue&type=style&index=0&id=d5150516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5150516",
  null
  
)

export default component.exports